<div class="dialog-body">
  <ng-content select="[body]"></ng-content>
</div>
<div class="dialog-footer row">
  <ng-content select="[footer]"></ng-content>
</div>

